import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { forwardRef } from "react";
export const Skeleton = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { className, height, isText, width, style, variant = "square" } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("box-border", isText ? "py-0.5" : undefined, className),
        ref: ref,
        style: {
            width,
            height,
            ...style
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: classNames("box-border h-full w-full animate-shimmer bg-grey-3 bg-skeleton", {
                "rounded-full": variant === "round",
                "rounded-2": variant === "square"
            }),
            "data-variant": variant,
            style: {
                animationFillMode: "forwards",
                backgroundSize: "200px 100%",
                backgroundPositionX: "100%"
            }
        })
    });
});
Skeleton.displayName = "Skeleton";
